import { render, staticRenderFns } from "./caseCenter.vue?vue&type=template&id=946a313e&scoped=true"
import script from "./caseCenter.vue?vue&type=script&lang=js"
export * from "./caseCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946a313e",
  null
  
)

export default component.exports